import { useMemo } from 'react';
import { DescriptorType, FieldListObject } from '@fabric-ui/components';
import { CALCULATED_DIMENSIONS_GROUP } from '@views/CalculateDimensions/utils';
import { useAvContext } from '../context/AvContextProvider';
import { parseCalcDimType } from '../context/useCalcDims';

const useGlobalInteractiveFilters = (): FieldListObject[] => {
  const {
    accountEntities: { aggProjs },
    calculatedDimensions,
  } = useAvContext();
  return useMemo(() => {
    const aggFields = Object.values(aggProjs).reduce(
      (allFieldsToFilterBy, { fieldList: { INTERACTIVE } }) => ({
        ...allFieldsToFilterBy,
        ...INTERACTIVE.reduce((projFieldsToFilterBy, field) => {
          const key = `${field.mainProjId.name} - ${field.group} - ${field.name}`;
          return field.visibilityConfig.config.hidden
            ? projFieldsToFilterBy
            : {
                ...projFieldsToFilterBy,
                [key]: {
                  ...field,
                  otherAliases: [...(allFieldsToFilterBy[key]?.otherAliases ?? []), field.value],
                },
              };
        }, {}),
      }),
      {}
    );

    const calcFields = calculatedDimensions.all.reduce((acc, calcDim) => {
      const key = `calculated - ${calcDim.systemName}`;
      const type = parseCalcDimType(calcDim.type);
      return calcDim.hidden
        ? acc
        : {
            ...acc,
            [key]: {
              value: calcDim.systemName,
              title: calcDim.displayName,
              name: calcDim.systemName,
              group: CALCULATED_DIMENSIONS_GROUP,
              type: type ? (DescriptorType[type] ?? type) : type,
              mainProjId: { name: 'calculated' },
              otherAliases: [calcDim.systemName],
            },
          };
    }, {});

    return [...Object.values(aggFields), ...Object.values(calcFields)] as FieldListObject[];
  }, [aggProjs, calculatedDimensions.all]);
};

export default useGlobalInteractiveFilters;
